export const mapVacancyDistributions = (
  positionStateDistributions = [],
  states = [],
  centreMap = {},
  reservationCategories = [],
  disabilities = [],
  cities = [],
) => {
  if (!Array.isArray(positionStateDistributions)) return [];

  return positionStateDistributions.map((stateDist) => {
    const stateName =
      states.find((s) => s.state_id === stateDist.stateId)?.state_name || "-";
    const interviewCentreName = centreMap[stateDist.cityId] || "-";

    const cityName =
      cities.find((c) => c.city_id === stateDist.cityId)?.city_name || "-";
    const categories = {};
    const disability = {};

    reservationCategories.forEach((cat) => {
      categories[cat.category_id] = 0;
    });

    disabilities.forEach((dis) => {
      disability[dis.disability_id] = 0;
    });
    (stateDist.positionCategoryDistributions || []).forEach((item) => {
      if (!item.isDisability && item.reservationCategoryId) {
        categories[item.reservationCategoryId] =
          (categories[item.reservationCategoryId] || 0) + item.vacancyCount;
      }

      if (item.isDisability && item.disabilityCategoryId) {
        disability[item.disabilityCategoryId] =
          (disability[item.disabilityCategoryId] || 0) + item.vacancyCount;
      }
    });

    return {
      state_id: stateDist.stateId,
      state_name: stateName,
      city_id: stateDist.cityId,
      city_name: cityName,
      interview_centre: interviewCentreName,
      total: stateDist.totalVacancies ?? 0,
      categories,
      disability,
    };
  });
};
